import { Globe } from "lucide-react";
import { useI18n, LANGS } from "@/i18n/I18nContext";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center gap-1 rounded-full bg-slate-100 p-0.5 ${compact ? "" : "border border-slate-200"}`} data-testid="language-switcher">
      {!compact && <Globe className="w-3.5 h-3.5 text-slate-400 ml-1.5" />}
      {LANGS.map((l) => (
        <button key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-${l.code}`}
          className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${lang === l.code ? "bg-emerald-600 text-white" : "text-slate-500 hover:text-slate-800"}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
};
